const GOLD = '#D4AF37';
const TRACK = '#3D2B1F';

interface CircularProgressProps {
  /** 0–100 */
  progress: number;
  size?: number;
  strokeWidth?: number;
  /** e.g. "Associate" – no ring for Certified Broker */
  showOnlyForTier?: 'Associate';
  tier?: string;
  className?: string;
}

export default function CircularProgress({
  progress,
  size = 36,
  strokeWidth = 4,
  showOnlyForTier,
  tier,
  className = '',
}: CircularProgressProps) {
  if (showOnlyForTier === 'Associate' && tier !== 'Associate') {
    return (
      <span className="text-gold text-xs font-medium" title="Certified Broker">
        ✓
      </span>
    );
  }

  const r = (size - strokeWidth) / 2;
  const cx = size / 2;
  const circumference = 2 * Math.PI * r;
  const clamped = Math.min(100, Math.max(0, progress));
  const dash = (clamped / 100) * circumference;

  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      title={`${clamped.toFixed(0)}% to $50k`}
    >
      <svg width={size} height={size} className="rotate-[-90deg] shrink-0">
        <circle
          cx={cx}
          cy={cx}
          r={r}
          fill="none"
          stroke={TRACK}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={cx}
          cy={cx}
          r={r}
          fill="none"
          stroke={GOLD}
          strokeWidth={strokeWidth}
          strokeDasharray={`${dash} ${circumference - dash}`}
          strokeLinecap="round"
        />
      </svg>
      <span
        className="absolute inset-0 flex items-center justify-center text-[10px] font-medium text-gold tabular-nums pointer-events-none"
        style={{ lineHeight: 1 }}
      >
        {clamped >= 100 ? '✓' : `${Math.round(clamped)}%`}
      </span>
    </div>
  );
}
